import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  Input,
  PasswordInput,
 
  Checkbox,
  Spinner,
  Alert,
} from "./ui";
import AuthService from "../services/AuthService";
import {
  Zap,
  Shield,
  Clock,
  QrCode,
  User,
  CreditCard,
  Phone,
  Mail,
  Lock,
  X,
  UserCheck,
} from "lucide-react";

function NewAcconunt() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (window.location.search.includes("cadastro") || window.location.hash.includes("cadastro")) {
      setVisible(true);
    }

    const handleOpenModal = () => setVisible(true);
    window.addEventListener("open-register-modal", handleOpenModal);
    return () => window.removeEventListener("open-register-modal", handleOpenModal);
  }, []);

  const auth_service = new AuthService();

  const [nome, setNome] = useState("");
  const [sobrenome, setSobrenome] = useState("");
  const [cpf, setCPF] = useState("");
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [tipo_usuario] = useState("Corredor");
  const [telefone, setTelefone] = useState("");
  const [is_maiorIdade, setIsMaiorIdade] = useState(false);
  const [, setId_user] = useState(null);
  const [disableButtom, setDisableButtom] = useState(false);
  const [disableLoadSpinner, setDisableLoadSpinner] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [messageSeverity, setMessageSeverity] = useState("success");
  const [messageText, setMessageText] = useState("");
  const [hideButtom, setHideButtom] = useState(true);

  const features = [
    {
      icon: <Zap className="w-5 h-5 text-urb-primary" />,
      title: "INSCRIÇÃO RÁPIDA",
      desc: "Cadastro em menos de 2 minutos.",
    },
    {
      icon: <Shield className="w-5 h-5 text-urb-primary" />,
      title: "PAGAMENTO SEGURO",
      desc: "Seus dados protegidos com tecnologia de ponta.",
    },
    {
      icon: <Clock className="w-5 h-5 text-urb-primary" />,
      title: "ACOMPANHE TUDO",
      desc: "Resultados, avisos e novidades em tempo real.",
    },
    {
      icon: <QrCode className="w-5 h-5 text-urb-primary" />,
      title: "RETIRADA DE KIT",
      desc: "Retire seu kit com QR Code direto no app.",
    },
  ];

function maskCPF(value) {
  if (!value) return "";
  let v = value.replace(/\D/g, "");
  if (v.length > 11) v = v.substring(0, 11);
  if (v.length > 9) {
    return v.replace(/^(\d{3})(\d{3})(\d{3})(\d{1,2})/, "$1.$2.$3-$4");
  } else if (v.length > 6) {
    return v.replace(/^(\d{3})(\d{3})(\d{1,3})/, "$1.$2.$3");
  } else if (v.length > 3) {
    return v.replace(/^(\d{3})(\d{1,3})/, "$1.$2");
  }
  return v;
}

function maskPhone(value) {
  if (!value) return "";
  let v = value.replace(/\D/g, "");
  if (v.length > 11) v = v.substring(0, 11);
  if (v.length > 10) {
    return v.replace(/^(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
  } else if (v.length > 6) {
    return v.replace(/^(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3");
  } else if (v.length > 2) {
    return v.replace(/^(\d{2})(\d{0,5})/, "($1) $2");
  }
  return v;
}

  async function handleEmailUserName(e) {
    if (e) e.preventDefault();

    if (!nome || nome.trim() === "") {
      setMessageSeverity("error");
      setMessageText("Por favor, insira seu nome.");
      setShowMessage(true);
      return;
    }

    if (!sobrenome || sobrenome.trim() === "") {
      setMessageSeverity("error");
      setMessageText("Por favor, insira seu sobrenome.");
      setShowMessage(true);
      return;
    }

    const validateCPF = (cpfStr) => {
      let strCPF = (cpfStr || "").replace(/[^\d]+/g, "");
      if (strCPF === "" || strCPF.length !== 11 || /^(\d)\1{10}$/.test(strCPF))
        return false;
      let soma = 0;
      for (let i = 1; i <= 9; i++)
        soma += parseInt(strCPF.substring(i - 1, i)) * (11 - i);
      let resto = (soma * 10) % 11;
      if (resto === 10 || resto === 11) resto = 0;
      if (resto !== parseInt(strCPF.substring(9, 10))) return false;
      soma = 0;
      for (let i = 1; i <= 10; i++)
        soma += parseInt(strCPF.substring(i - 1, i)) * (12 - i);
      resto = (soma * 10) % 11;
      if (resto === 10 || resto === 11) resto = 0;
      if (resto !== parseInt(strCPF.substring(10, 11))) return false;
      return true;
    };

    const cleanCpf = (cpf || "").replace(/\D/g, "");
    if (!cleanCpf) {
      setMessageSeverity("error");
      setMessageText("A criação da conta não pode ser realizada sem o CPF.");
      setShowMessage(true);
      return;
    }

    if (!validateCPF(cleanCpf)) {
      setMessageSeverity("error");
      setMessageText("Por favor, insira um CPF válido para criar a conta.");
      setShowMessage(true);
      return;
    }

    const cleanTelefone = (telefone || "").replace(/\D/g, "");
    if (!cleanTelefone) {
      setMessageSeverity("error");
      setMessageText("A criação da conta não pode ser realizada sem o telefone.");
      setShowMessage(true);
      return;
    }

    if (cleanTelefone.length < 10) {
      setMessageSeverity("error");
      setMessageText("Por favor, insira um telefone válido com DDD (mínimo 10 dígitos) para criar a conta.");
      setShowMessage(true);
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email || !emailRegex.test(email.trim())) {
      setMessageSeverity("error");
      setMessageText("Por favor, insira um e-mail válido.");
      setShowMessage(true);
      return;
    }

    if (email.toLowerCase().includes("teste")) {
      setMessageSeverity("error");
      setMessageText("E-mails de teste não são permitidos.");
      setShowMessage(true);
      return;
    }

    if (!senha || senha.trim() === "") {
      setMessageSeverity("error");
      setMessageText("Por favor, insira uma senha.");
      setShowMessage(true);
      return;
    }

    setDisableButtom(true);
    setDisableLoadSpinner(true);
    setShowMessage(false);

    const novoUsuario = email.split("@")[0];
    await handleRegister(novoUsuario);
  }

  async function handleInfoAdicional(userId) {
    const cleanCpf = (cpf || "").replace(/\D/g, "");
    const cleanTelefone = (telefone || "").replace(/\D/g, "");
    let data2 = {
      telefone1: cleanTelefone,
      telefone: cleanTelefone,
      cpf: cleanCpf,
      is_maior_idade: is_maiorIdade,
      id_usuario: parseInt(userId),
    };

    try {
      const response = await auth_service.setInfoAdicional(
        JSON.stringify(data2)
      );
      setDisableLoadSpinner(false);
      if (response.ok) {
        setMessageSeverity("success");
        setMessageText(
          "Usuário registrado com sucesso! Você já pode retornar para a tela de login."
        );
        setShowMessage(true);
        setHideButtom(false);
      } else {
        setMessageSeverity("error");
        let infoErrorMsg =
          "Usuário criado, mas ocorreu um erro ao salvar as informações adicionais.";
        try {
          const errorJson = await response.json();
          if (typeof errorJson === "object" && errorJson !== null) {
            const details = Object.entries(errorJson)
              .map(
                ([k, v]) =>
                  `${k}: ${Array.isArray(v) ? v.join(" ") : v}`
              )
              .join(" | ");
            if (details) infoErrorMsg = details;
          }
        } catch (e) {}
        setMessageText(infoErrorMsg);
        setShowMessage(true);
        setDisableButtom(false);
      }
    } catch (err) {
      console.log(err);
      setDisableLoadSpinner(false);
      setMessageSeverity("error");
      setMessageText("Ocorreu um erro ao salvar as informações adicionais.");
      setShowMessage(true);
      setDisableButtom(false);
    }
  }

  async function handleRegister(username) {
    const cleanCpf = (cpf || "").replace(/\D/g, "");
    const cleanTelefone = (telefone || "").replace(/\D/g, "");

    if (!cleanCpf || cleanCpf.length !== 11 || !cleanTelefone || cleanTelefone.length < 10) {
      setDisableLoadSpinner(false);
      setDisableButtom(false);
      setMessageSeverity("error");
      setMessageText(
        "A criação da conta não pode ser realizada se o CPF e o telefone não forem fornecidos."
      );
      setShowMessage(true);
      return;
    }

    const tipoName = typeof tipo_usuario === "object" ? tipo_usuario?.name || "Corredor" : tipo_usuario || "Corredor";
    let data = {
      first_name: nome,
      last_name: sobrenome,
      email: email,
      username: username + "_" + tipoName,
      password: senha,
      tipo_usuario: tipoName,
      cpf: cleanCpf,
      telefone: cleanTelefone,
      telefone1: cleanTelefone,
      is_active: true,
    };

    try {
      const response = await auth_service.setRegister(JSON.stringify(data));

      if (!response.ok) {
        setDisableLoadSpinner(false);
        setDisableButtom(false);
        setMessageSeverity("error");
        const responseBody = await response.text();
        let errorMsg = "";
        try {
          const parsed = JSON.parse(responseBody);
          if (typeof parsed === "string") {
            errorMsg = parsed;
          } else if (
            parsed.detail ||
            parsed.message ||
            parsed.erro ||
            parsed.error
          ) {
            errorMsg =
              parsed.detail ||
              parsed.message ||
              parsed.erro ||
              parsed.error;
          } else if (typeof parsed === "object" && parsed !== null) {
            const messages = [];
            for (const [key, value] of Object.entries(parsed)) {
              const valText = Array.isArray(value)
                ? value.join(" ")
                : String(value);
              if (key === "non_field_errors" || key === "detail") {
                messages.push(valText);
              } else if (key === "username") {
                messages.push(
                  valText.includes("already exists") ||
                    valText.includes("já existe")
                    ? "Este nome de usuário já está em uso."
                    : `Usuário: ${valText}`
                );
              } else if (key === "email") {
                messages.push(
                  valText.includes("already exists") ||
                    valText.includes("já existe")
                    ? "Este e-mail já está cadastrado."
                    : `E-mail: ${valText}`
                );
              } else {
                messages.push(`${key}: ${valText}`);
              }
            }
            if (messages.length > 0) {
              errorMsg = messages.join(" | ");
            }
          }
        } catch (e) {
          if (
            responseBody.toLowerCase().includes("already exists") ||
            responseBody.toLowerCase().includes("já existe")
          ) {
            errorMsg = "Um usuário com esse email ou login já existe.";
          }
        }

        setMessageText(
          errorMsg ||
            "Erro ao registrar usuário. Verifique os dados preenchidos."
        );
        setShowMessage(true);
        return;
      }

      const responseData = await response.json();
      setId_user(responseData.id);
      await handleInfoAdicional(responseData.id);
    } catch (error) {
      console.log(error);
      setDisableLoadSpinner(false);
      setDisableButtom(false);
      setMessageSeverity("error");
      setMessageText("Erro de conexão ao tentar registrar. Tente novamente.");
      setShowMessage(true);
    }
  }

  const handleClose = () => {
    setVisible(false);
    setShowMessage(false);
    setDisableButtom(false);
    setDisableLoadSpinner(false);
    setHideButtom(true);
  };

  return (
    <div>
      <div className="text-center w-full text-xs md:text-sm mt-3">
        <span className="text-slate-400">Ainda não tem uma conta? </span>
        <button
          type="button"
          className="border-none bg-transparent cursor-pointer p-0 font-bold hover:underline text-urb-primary"
          onClick={() => setVisible(true)}
        >
          Crie agora mesmo!
        </button>
      </div>

      <Modal
        visible={visible}
        isOpen={visible}
        onHide={handleClose}
        onClose={handleClose}
        maxWidth="max-w-5xl w-full"
        className="p-0 overflow-hidden"
      >
        <div className="relative flex flex-col md:flex-row w-full overflow-hidden bg-urb-dark">
          {/* Close Button */}
          <button
            type="button"
            onClick={handleClose}
            className="absolute top-3 right-3 text-slate-400 hover:text-white z-20 p-2 bg-black/60 rounded-full border-none cursor-pointer transition-colors"
            aria-label="Fechar"
          >
            <X className="w-5 h-5" />
          </button>

          {/* Left Hero Panel */}
          <div className="w-full md:w-5/12 p-6 md:p-8 flex flex-col justify-between bg-black/40 border-r border-urb-border/50 relative overflow-hidden">
            <div>
              {/* Logo */}
              <div className="flex items-center gap-2 mb-6">
                <img
                  src={require("../statics/img/escudo-verde.png")}
                  alt="UR"
                  className="h-8"
                />
                <span className="text-xl font-black tracking-wider text-white">
                  URB <span className="text-urb-primary">RACE</span>
                </span>
              </div>

              {/* Hero Main Title */}
              <h2 className="text-2xl md:text-3xl font-black uppercase text-white tracking-tight leading-tight my-4">
                FAÇA PARTE <br className="hidden md:inline" />
                <span className="text-urb-primary">DA PRÓXIMA</span>{" "}
                <br className="hidden md:inline" />
                <span>CORRIDA.</span>
              </h2>

              <p className="text-xs text-slate-400 mb-6 leading-relaxed">
                Crie seu perfil e viva{" "}
                <span className="font-bold text-urb-primary">
                  experiências únicas
                </span>{" "}
                nas melhores provas urbanas.
              </p>

              {/* Features List */}
              <div className="hidden md:flex flex-col gap-4 mb-6">
                {features.map((item, idx) => (
                  <div key={idx} className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-xl bg-urb-primary/10 border border-urb-primary/30 flex items-center justify-center shrink-0">
                      {item.icon}
                    </div>
                    <div>
                      <h4 className="text-xs font-bold uppercase text-white m-0 tracking-wide">
                        {item.title}
                      </h4>
                      <p className="text-[11px] text-slate-400 m-0 mt-0.5">
                        {item.desc}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Bottom Graphic */}
            <div className="hidden md:flex relative mt-auto pt-4 items-end justify-center overflow-hidden min-h-[120px]">
              <img
                src={require("../statics/img/MERO-ATLETAS.png")}
                alt="Runner"
                className="relative z-10 max-h-32 object-contain drop-shadow-[0_0_12px_rgba(138,230,0,0.3)]"
              />
            </div>
          </div>

          {/* Right Form Panel */}
          <div className="w-full md:w-7/12 p-6 md:p-8 flex flex-col justify-between bg-urb-card/60">
            <div>
              {/* Header */}
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 rounded-xl border border-urb-primary/40 bg-urb-primary/10 flex items-center justify-center shrink-0">
                  <UserCheck className="w-5 h-5 text-urb-primary" />
                </div>
                <div>
                  <h3 className="text-lg md:text-xl font-black uppercase text-white m-0 tracking-wide">
                    CRIAR SUA <span className="text-urb-primary">CONTA</span>
                  </h3>
                  <p className="text-xs text-slate-400 m-0 mt-0.5">
                    É rápido, seguro e gratuito.
                  </p>
                </div>
              </div>

              {/* Form */}
              <form onSubmit={handleEmailUserName} className="flex flex-col gap-4">
                {/* Nome & Sobrenome */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <div className="flex flex-col gap-1.5">
                    <label className="text-[10px] font-bold uppercase tracking-wider text-slate-400">
                      NOME *
                    </label>
                    <Input
                      id="nome"
                      value={nome}
                      onChange={(e) => setNome(e.target.value)}
                      placeholder="Seu nome"
                      icon={User}
                      required
                    />
                  </div>
                  <div className="flex flex-col gap-1.5">
                    <label className="text-[10px] font-bold uppercase tracking-wider text-slate-400">
                      SOBRENOME *
                    </label>
                    <Input
                      id="sobrenome"
                      value={sobrenome}
                      onChange={(e) => setSobrenome(e.target.value)}
                      placeholder="Seu sobrenome"
                      icon={User}
                      required
                    />
                  </div>
                </div>

                {/* CPF */}
                <div className="flex flex-col gap-1.5">
                  <label className="text-[10px] font-bold uppercase tracking-wider text-slate-400">
                    CPF *
                  </label>
                  <Input
                    id="cpf"
                    value={cpf}
                    onChange={(e) => setCPF(maskCPF(e.target.value))}
                    maxLength="14"
                    placeholder="000.000.000-00"
                    icon={CreditCard}
                    required
                  />
                </div>

                {/* Telefone & Email */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <div className="flex flex-col gap-1.5">
                    <label className="text-[10px] font-bold uppercase tracking-wider text-slate-400">
                      TELEFONE *
                    </label>
                    <Input
                      id="telefone"
                      value={telefone}
                      onChange={(e) => setTelefone(maskPhone(e.target.value))}
                      placeholder="(00) 00000-0000"
                      maxLength="15"
                      icon={Phone}
                      required
                    />
                  </div>
                  <div className="flex flex-col gap-1.5">
                    <label className="text-[10px] font-bold uppercase tracking-wider text-slate-400">
                      E-MAIL *
                    </label>
                    <Input
                      id="email"
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="seu@email.com"
                      icon={Mail}
                      required
                    />
                  </div>
                </div>

                {/* Senha */}
                <div className="flex flex-col gap-1.5">
                    <label className="text-[10px] font-bold uppercase tracking-wider text-slate-400">
                      SENHA *
                    </label>
                    <PasswordInput
                      id="senha"
                      value={senha}
                      onChange={(e) => setSenha(e.target.value)}
                      placeholder="Crie uma senha"
                      icon={Lock}
                      required
                    />
                  </div>

                {/* Maior de idade */}
                <div className="flex items-center gap-2 mt-1">
                  <Checkbox
                    id="is_maiorIdade"
                    checked={is_maiorIdade}
                    onChange={(e) => setIsMaiorIdade(e.checked)}
                  />
                  <label
                    htmlFor="is_maiorIdade"
                    className="text-xs text-slate-300 font-medium cursor-pointer"
                  >
                    Declaro que sou maior de 18 anos.
                  </label>
                </div>

                {/* Button & Feedback */}
                <div className="w-full mt-2">
                  {hideButtom && (
                    <Button
                      type="submit"
                      variant="primary"
                      size="lg"
                      disabled={
                        disableButtom ||
                        (cpf || "").replace(/\D/g, "").length !== 11 ||
                        (telefone || "").replace(/\D/g, "").length < 10
                      }
                      className="w-full font-black text-sm uppercase py-3.5 tracking-wider shadow-lg flex items-center justify-center gap-2"
                    >
                      <UserCheck className="w-5 h-5" />
                      CRIAR CONTA
                    </Button>
                  )}

                  {showMessage && (
                    <Alert
                      severity={messageSeverity}
                      className="mt-3"
                      onClose={() => setShowMessage(false)}
                    >
                      {messageText}
                    </Alert>
                  )}

                  {disableLoadSpinner && (
                    <div className="flex justify-center mt-3">
                      <Spinner size="md" />
                    </div>
                  )}
                </div>
              </form>

              {/* Footer */}
              <div className="text-center mt-4 pt-3 border-t border-urb-border/60">
                <span className="text-xs text-slate-400 block mb-1">
                  JÁ TEM UMA CONTA?
                </span>
                <button
                  type="button"
                  className="border-none bg-transparent cursor-pointer p-0 font-bold text-sm text-urb-primary hover:underline"
                  onClick={handleClose}
                >
                  Entrar
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default NewAcconunt;
